export const productData = [
    {
        img: require('../../images/pizza-1.jpg').default,
        alt: 'Pizza',
        name: 'Supreme Pizza',
        desc: 'Marinara sauce, basil, Italian sausage, roma tomatoes, olives, and pesto',
        price: 'Rs. 350',
        button: 'Add To Cart'
    },
    {
        img: require('../../images/pizza-2.jpg').default,
        alt: 'Pizza',
        name: 'Hawaiian Paradise',
        desc: 'Marinara sauce, basil, Italian sausage, roma tomatoes, olives, and pesto',
        price: 'Rs. 450',
        button: 'Add To Cart'
    },
    {
        img: require('../../images/pizza-4.jpg').default,
        alt: 'Pizza',
        name: 'Veggie Overload',
        desc: 'Marinara sauce, basil, Italian sausage, roma tomatoes, olives, and pesto',
        price: 'Rs. 250',
        button: 'Add To Cart'
    }
]


export const productDataTwo = [
    {
        img: require('../../images/dessert1.jpg').default,
        alt: 'Pizza',
        name: 'Supreme Pizza',
        desc: 'Marinara sauce, basil, Italian sausage, roma tomatoes, olives, and pesto',
        price: 'Rs. 350',
        button: 'Add To Cart'
    },
    {
        img: require('../../images/dessert2.jpg').default,
        alt: 'Pizza',
        name: 'Hawaiian Paradise',
        desc: 'Marinara sauce, basil, Italian sausage, roma tomatoes, olives, and pesto',
        price: 'Rs. 450',
        button: 'Add To Cart'
    },
    {
        img: require('../../images/dessert3.jpg').default,
        alt: 'Pizza',
        name: 'Veggie Overload',
        desc: 'Marinara sauce, basil, Italian sausage, roma tomatoes, olives, and pesto',
        price: 'Rs. 250',
        button: 'Add To Cart'
    }
]